import { AppShell } from '@/components/shell/AppShell';
import { ADMIN_NAV } from '@/components/shell/nav-config';
import { RequireAuth } from '@/features/auth/auth-guard';
import { useSession } from '@/features/auth/auth-store';
import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin')({
  component: AdminLayout,
});

function AdminLayout() {
  const session = useSession();
  if (session && session.user.platformRole !== 'admin') {
    return <Navigate to="/app" replace />;
  }
  return (
    <RequireAuth>
      <AppShell sections={ADMIN_NAV} />
    </RequireAuth>
  );
}
